import ConversationAttachmentWellViewState from '../schema/ConversationAttachmentWellViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateConversationAttachmentWellMaxHeight',
    function updateConversationAttachmentWellMaxHeight(
        attachmentWell: ConversationAttachmentWellViewState
    ) {
        attachmentWell.maxHeight = (window.innerHeight || document.body.clientHeight) - 200;
    }
);
